var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3818_84",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.940796,
    y: 0.446121,
    width: 35,
    height: 35,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3818_84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1491 25.2378H25.7324V22.3211H11.1491V25.2378ZM18.4408 20.8628L24.2741 15.0295L22.2324 12.9878L19.8991 15.2482V9.19612H16.9824V15.2482L14.6491 12.9878L12.6074 15.0295L18.4408 20.8628ZM18.4408 32.5295C16.4234 32.5295 14.5276 32.1466 12.7533 31.381C10.9789 30.6154 9.43555 29.5763 8.12305 28.2638C6.81055 26.9513 5.77148 25.4079 5.00586 23.6336C4.24023 21.8593 3.85742 19.9635 3.85742 17.9461C3.85742 15.9288 4.24023 14.0329 5.00586 12.2586C5.77148 10.4843 6.81055 8.94091 8.12305 7.62841C9.43555 6.31591 10.9789 5.27685 12.7533 4.51123C14.5276 3.7456 16.4234 3.36279 18.4408 3.36279C20.4581 3.36279 22.3539 3.7456 24.1283 4.51123C25.9026 5.27685 27.446 6.31591 28.7585 7.62841C30.071 8.94091 31.11 10.4843 31.8756 12.2586C32.6413 14.0329 33.0241 15.9288 33.0241 17.9461C33.0241 19.9635 32.6413 21.8593 31.8756 23.6336C31.11 25.4079 30.071 26.9513 28.7585 28.2638C27.446 29.5763 25.9026 30.6154 24.1283 31.381C22.3539 32.1466 20.4581 32.5295 18.4408 32.5295ZM18.4408 29.6128C21.6977 29.6128 24.4564 28.4826 26.7168 26.2222C28.9772 23.9617 30.1074 21.2031 30.1074 17.9461C30.1074 14.6892 28.9772 11.9305 26.7168 9.67008C24.4564 7.40966 21.6977 6.27946 18.4408 6.27946C15.1838 6.27946 12.4251 7.40966 10.1647 9.67008C7.9043 11.9305 6.77409 14.6892 6.77409 17.9461C6.77409 21.2031 7.9043 23.9617 10.1647 26.2222C12.4251 28.4826 15.1838 29.6128 18.4408 29.6128Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.deb519ff0cab2ffd0c6318c9633016f5.svg";
export { ForwardRef as ReactComponent };